// extracted by mini-css-extract-plugin
module.exports = {"next":"Styles_next__E9EtV","pagination":"Styles_pagination___fNE_","previous":"Styles_previous__2H4yT","link":"Styles_link__2w2vi","disableLink":"Styles_disableLink__1835t"};